import React, { useState } from "react";
import s from "./Cards.module.scss";

import SelectField from "../../../../../../global components/Forms/SelectField/SelectField";
import { formatNumber } from "../../../../../../libs/api/userSession";

type CardProp = {
  handleFilters: (value: string) => void;
  cardTitle: string;
  cardStat: number;
  filters?: string | false;
};

function Card({ filters, cardStat, cardTitle,handleFilters }: CardProp) {
  const [filter, setFilter] = useState<string>("7");
  function handleFilter(value: string) {
    setFilter(value);
    handleFilters(value)
  }
  return (
    <div className={s.wrapper}>
      <h5 className={s.label}>{cardTitle}</h5>
      <span className={s.numbers}>
        <h6 className={s.stat}>{formatNumber(cardStat)}</h6>

        <SelectField
          bordered
          suffixIcon={<></>}
          rootClassName={s.select}
          wrapperClassname={s.SelectWrapper}
          defaultValue={"7"}
          value={filters || filter}
          onChange={(value: any) => handleFilter(value)}
          style={{
            fontSize: "10px",
            maxHeight: "16px",
            color: "#6A6767",
          }}
          options={[
            { value: "7", label: "This week" },
            { value: "31", label: "This month" },
            { value: "365", label: "This year" },
          ]}
        />
      </span>
    </div>
  );
}

export default Card;
